import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_recaptcha_01dc8496 from 'nuxt_plugin_recaptcha_01dc8496' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_templatesplugin7394963d_d656c6de from 'nuxt_plugin_templatesplugin7394963d_d656c6de' // Source: ./templates.plugin.7394963d.js (mode: 'all')
import nuxt_plugin_apollomodule_77b2e812 from 'nuxt_plugin_apollomodule_77b2e812' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_buefy_fd0a7cd2 from 'nuxt_plugin_buefy_fd0a7cd2' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_35e2a869 from 'nuxt_plugin_iconplugin_35e2a869' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_global_64c9a38c from 'nuxt_plugin_global_64c9a38c' // Source: ../plugins/global (mode: 'all')
import nuxt_plugin_helpers_0e9b0ece from 'nuxt_plugin_helpers_0e9b0ece' // Source: ../plugins/helpers (mode: 'all')
import nuxt_plugin_components_2c318a2d from 'nuxt_plugin_components_2c318a2d' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_utilscomponentloader_6fc6333c from 'nuxt_plugin_utilscomponentloader_6fc6333c' // Source: ../plugins/utils-component-loader.js (mode: 'all')
import nuxt_plugin_timers_38c1e736 from 'nuxt_plugin_timers_38c1e736' // Source: ../plugins/timers (mode: 'client')
import nuxt_plugin_veevalidate_6a1e9ac4 from 'nuxt_plugin_veevalidate_6a1e9ac4' // Source: ../plugins/vee-validate (mode: 'client')
import nuxt_plugin_slideout_b010ae58 from 'nuxt_plugin_slideout_b010ae58' // Source: ../plugins/slideout (mode: 'client')
import nuxt_plugin_styleguide_4fa80b02 from 'nuxt_plugin_styleguide_4fa80b02' // Source: ../plugins/styleguide (mode: 'client')
import nuxt_plugin_eventbus_ef907a54 from 'nuxt_plugin_eventbus_ef907a54' // Source: ../plugins/event-bus (mode: 'client')
import nuxt_plugin_prism_f9fb4c6c from 'nuxt_plugin_prism_f9fb4c6c' // Source: ../plugins/prism (mode: 'client')
import nuxt_plugin_sentryclient_682d4b02 from 'nuxt_plugin_sentryclient_682d4b02' // Source: ../plugins/sentry-client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"src":"https:\u002F\u002Fplausible.helios.pyango.ch\u002Fjs\u002Fscript.js","defer":true,"data-domain":"app.sybill.io"},{"innerHTML":"\n            !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement(\"script\");t.src=\"https:\u002F\u002Fwww.redditstatic.com\u002Fads\u002Fpixel.js\",t.async=!0;var s=d.getElementsByTagName(\"script\")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_fxuw93885899');rdt('track', 'PageVisit');\n          ","type":"text\u002Fjavascript"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KV7VCC9')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fpictures.helios.pyango.ch\u002F?image=\u002Fmedia-files\u002Fpictures\u002Fsybill-time-tracking-preview-image.jpg&width=1200&height=630&to=webp"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fpictures.helios.pyango.ch\u002F?image=\u002Fmedia-files\u002Fpictures\u002Fsybill-time-tracking-preview-image.jpg&width=1200&height=630&to=webp"},{"name":"msapplication-TileColor","content":"#0797a0"},{"name":"msapplication-TileImage","content":"\u002F_favicons\u002Fmstile-144x144.png"},{"name":"msapplication-config","content":"\u002F_favicons\u002Fbrowserconfig.xml"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon\u002Ffavicon.svg","media":"(prefers-color-scheme: light)"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon\u002Ffavicon-dark.svg","media":"(prefers-color-scheme: dark)"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon\u002Ffavicon-dark.png","media":"(prefers-color-scheme: dark)"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon\u002Ffavicon.png","media":"(prefers-color-scheme: light)"},{"type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@5.8.55\u002Fcss\u002Fmaterialdesignicons.min.css","rel":"preload","as":"style","onload":"this.rel='stylesheet'"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002F_favicons\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002F_favicons\u002Ffavicon-32x32.png","media":"(prefers-color-scheme: light)"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002F_favicons\u002Ffavicon-32-darkmode.png","media":"(prefers-color-scheme: dark)"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002F_favicons\u002Ffavicon-16x16.png","media":"(prefers-color-scheme: light)"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002F_favicons\u002Ffavicon-16-darkmode.png","media":"(prefers-color-scheme: dark)"},{"href":"\u002F_favicons\u002Fsafari-pinned-tab.svg","color":"#5bbad5"},{"rel":"shortcut icon","href":"\u002F_favicons\u002Ffavicon.ico"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KV7VCC9&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_recaptcha_01dc8496 === 'function') {
    await nuxt_plugin_recaptcha_01dc8496(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin7394963d_d656c6de === 'function') {
    await nuxt_plugin_templatesplugin7394963d_d656c6de(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_77b2e812 === 'function') {
    await nuxt_plugin_apollomodule_77b2e812(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_fd0a7cd2 === 'function') {
    await nuxt_plugin_buefy_fd0a7cd2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_35e2a869 === 'function') {
    await nuxt_plugin_iconplugin_35e2a869(app.context, inject)
  }

  if (typeof nuxt_plugin_global_64c9a38c === 'function') {
    await nuxt_plugin_global_64c9a38c(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_0e9b0ece === 'function') {
    await nuxt_plugin_helpers_0e9b0ece(app.context, inject)
  }

  if (typeof nuxt_plugin_components_2c318a2d === 'function') {
    await nuxt_plugin_components_2c318a2d(app.context, inject)
  }

  if (typeof nuxt_plugin_utilscomponentloader_6fc6333c === 'function') {
    await nuxt_plugin_utilscomponentloader_6fc6333c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_timers_38c1e736 === 'function') {
    await nuxt_plugin_timers_38c1e736(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_6a1e9ac4 === 'function') {
    await nuxt_plugin_veevalidate_6a1e9ac4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_slideout_b010ae58 === 'function') {
    await nuxt_plugin_slideout_b010ae58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_styleguide_4fa80b02 === 'function') {
    await nuxt_plugin_styleguide_4fa80b02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eventbus_ef907a54 === 'function') {
    await nuxt_plugin_eventbus_ef907a54(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_prism_f9fb4c6c === 'function') {
    await nuxt_plugin_prism_f9fb4c6c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_682d4b02 === 'function') {
    await nuxt_plugin_sentryclient_682d4b02(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
